export default "__VITE_ASSET__a4532071__"